import { useEffect, useState } from 'react';
import { motionAllowed } from '../lib/motion';

// A little longer than the --motion-fast of a panel's way out, so it's gone before it's removed.
const LEAVE_MS = 140;

/**
 * Keeps a panel on the page for a moment after it's shut, so it can animate out. While it's
 * `leaving` it's already closed: make it inert, and let its styles take it away.
 */
export function usePresence(shown: boolean, leaveMs = LEAVE_MS) {
  const [leaving, setLeaving] = useState(false);
  const [wasShown, setWasShown] = useState(shown);
  if (shown !== wasShown) {
    setWasShown(shown);
    setLeaving(!shown && motionAllowed());
  }

  useEffect(() => {
    if (!leaving) return;
    const timer = setTimeout(() => {
      setLeaving(false);
    }, leaveMs);
    return () => {
      clearTimeout(timer);
    };
  }, [leaving, leaveMs]);

  return { present: shown || leaving, leaving };
}
